import { Button, Dialog, DialogContent, DialogActions, Stack, Box } from "@mui/material";
import regularEstimateImage from "../../images/regularEstimate.jpg"
import insuranceEstimateImage from "../../images/insuranceEstimate.jpg"

const EstimateOptionsDialog = ({
  open,
  regularEstimate,
  insuranceEstimate,
  close,
}) => {
  return (
    <Dialog open={open} onClose={close}>
      <DialogContent>
        <Stack direction="row" spacing={2}>
          <Stack className="card" sx={{ overflow: "hidden" }}>
            <Box
              className="text-end"
              component="img"
              sx={{
                width: "100%",
              }}
              style={{ "align-self": "start" }}
              alt="Regular Estimate"
              src={regularEstimateImage}
            />
            <Stack sx={{ margin: "10px" }}>
              <Button
                fullWidth
                className="btn btn-secondary align-self-start"
                variant="contained"
                onClick={regularEstimate}
              >
                Regular Estimate
              </Button>
            </Stack>
          </Stack>

          <Stack className="card" sx={{ overflow: "hidden" }}>
            <Box
              className="text-end"
              component="img"
              sx={{
                width: "100%",
              }}
              style={{ "align-self": "start" }}
              alt="Regular Estimate"
              src={insuranceEstimateImage}
            />
            <Stack sx={{ margin: "10px" }}>
              <Button
                fullWidth
                className="btn btn-secondary align-self-start"
                variant="contained"
                onClick={insuranceEstimate}
              >
                Insurance Estimate
              </Button>
            </Stack>
          </Stack>

        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          className="btn btn-primary white-text"
          variant="contained"
          onClick={close}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog >
  );
};
export default EstimateOptionsDialog;
